import React from 'react';

const CollapseSIdeNav: React.FC<{arrowDirection?: string}> = ({
  arrowDirection
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 -5 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        {arrowDirection === 'left' ? (
          <path
            d="M2.5 10L6.66667 14.1667M2.5 10L6.66667 5.83337M2.5 10H17.5"
            stroke="#024064"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        ) : (
          <path
            d="M17.5 9.99996L13.3333 5.83329M17.5 9.99996L13.3333 14.1666M17.5 9.99996L2.5 9.99996"
            stroke="#024064"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        )}
      </svg>
    </svg>
  );
};

export default CollapseSIdeNav;
